
import chapterClass from "@/class/interactive-image/chapter";
import axios from "@/axios";
import {viewModel} from "@/class/view-model";
import {volets} from "@/class/volets";
import store from "@/store/store";
import {DateTime, Media} from "@/class/data-type";
import {annotation} from "@/class/annotation/annotation";

export class story extends viewModel {
    
    objectType = "story";
    
    data = [
        {name: "name", type: String, default: "A renseigner"},
        {name: "synopsis", type: String, default: ""},
        {name: "title", type: String, default: ""},
        {name: "thumbnail", type: Media, default: new Media({type:"picture"})},
        {name: "creation_date", type: DateTime, default: new DateTime(), readonly: true},
        {name: "update_date", type: DateTime, default: new DateTime()},
    ]
    
    volets = new volets().set([
        {label: "Synoptic", component: ""},
        {label: "Detail", component: ""},
        {label: "Credits", component: ""},
        {label: "Settings", component: ""},
    ]);
    
    voletsContent = new volets().set([
        {label: "All", component: "", type:"all"},
        {label: "Map", component: "", type:"map"},
        {label: "Panorama", component: "", type: "panorama"},
        {label: "Article", component: "", type: "content_page"},
        {label: "Interactive Image", type:"interactive_image"},
        {label: "Video", type:"video"},
        {label: "Annotations", type:"annotation"},
    ]);
    
    constructor() {
        super();
        this.init();
    
        store.getters.getObjectTypesLink.forEach((type) => {
            this[type] = []
        })
    }
    
    getItems(type){
        
        if(type === "all"){
            let all = []
            store.getters.getObjectTypesLink.forEach((type) => {
                if(type === "annotation") return;
                all = [...all,...this[type]]
            })
            return all;
        }
        
        return this[type];
    }
   
    // LOAD
    async load(){
        
        if(!await super.load()){
            return false;
        }
    
        await this.loadContent()
        
        return true
    }
    
    async loadContent(){
        
        store.getters.getGlobalInfoLink.forEach((object) => {
            
            axios.get(object.route+"/?story_id="+this.getId())
                .then(response => {
                    
                    this[object.type] = [];
                    
                    if(object.type === "annotation"){
                        this[object.type].push(new annotation().setDataReq({text:"New annotation", story: this.getId()}))
                    }
                    response.data.forEach((data) => {
                        let classObject = new object.class()
                        classObject.setDataReq({...data,story:this.getId()});
                        this[object.type].push(classObject)
                    });
                    
                    console.log(this[object.type])
                })
                .catch(e => {
                    console.log(e)
                })
        });
    }
    
    getThumbnail(){
        return this.thumbnail.getMediaUrl();
    }
    
    getRoute(){
        return "/story/" + this.getId()
    }
}